import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import React, {Fragment, useEffect} from "react";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";
import {RegistrationFormSections} from "root/s360components/Registration/RegistrationPage";
import {RegistrationFilterNames} from "root/s360components/Registration/HookSubFormRegistrationFilters";

const DropdownClassList = ({control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, school_id, onChange, class_id_filter, setValue, onItemsLoaded = () => {}}) =>
{

    const fields = { url: '/school/' + school_id + '/classes', keyFieldName: 'class_id', labelFieldName: 'group_name', additionalFields: ['group_id']};

    const [ loading, items ] = useListboxFetch( fields ) ;

    //Prefils the filters when navigating from class view
    const findClassObjectByClassId = (class_id, items) =>
    {
        const matchedObject = items.find((classObject) => {
            return classObject.value === (+class_id_filter) ? classObject : null
        });

        setValue(name, matchedObject);
    }

    useEffect(() =>
    {
        if (loading === false)
        {
            //Hand the full class list up so callers can match other filters against it. Defaults to a no-op for existing usages.
            onItemsLoaded(items);

            if (items.length !== 0 && class_id_filter !== null)
            {
                findClassObjectByClassId(class_id_filter, items);
            }
        }
    },[loading])

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )

}

export default DropdownClassList;